<template>
  <div>
    <standard-import-dialog :dialogStandardImport.sync="dialogImport" v-if="dialogImport"></standard-import-dialog>
    <v-card>
      <v-toolbar color="secondary lighten-2" dark>
        <v-toolbar-title>{{ $t('standards_title')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <more-menu :items="more_menu" @itemimport="dialogImport = !dialogImport"></more-menu>
      </v-toolbar>
      <v-card
        v-for="(standard,standard_index) in loadedStandards"
        :key="standard_index"
        @click="$router.push({name: 'standard', params: { standardId: standard_index }})"
      >
        <v-card-text
          @click="$router.push({name: 'standard', params: { standardId: standard_index }})"
        >{{standard.name}} - {{standard.description}}</v-card-text>
      </v-card>
    </v-card>
  </div>
</template>

<i18n>
    {
        "de": {
            "standards_title": "Standards im Unternehmen",
            "standards_import_btn" : "Import Standard"
        },
        "en": {
            "standards_title": "Used Standards",
            "standards_import_btn" : "Import Standard"
        }
    }
</i18n>

<script>
import { mapGetters } from "vuex";
import { api } from "@/store/modules/standards";

// Dialogs
import StandardImportDialog from "@/components/dialogs/StandardImportDialog.vue";

// Controls
import MoreMenu from "@/components/snippets/MoreMenu.vue";

export default {
  data() {
    return {
      dialogImport: false,
      more_menu: [
        { title: this.$i18n.t("standards_import_btn"), event: "itemimport" }
      ]
    };
  },
  components: {
    MoreMenu,
    StandardImportDialog
  },
  computed: {
    ...mapGetters(api.namespace, [api.getters.loadedStandards])
  }
};
</script>
